<div class="modal__content cookiee">
    <div class="cookiee__age">
        <div class="cookiee__age-icon">
            18+
        </div>
        <div class="cookiee__age-text">
            <p>{{ $t('modals.cookie18.def.age') }}</p>
        </div>
    </div>

    <div class="cookiee__text" v-if="!isCC">
        <div class="cookiee__text-wrapper" v-if="!manageCookies">
            <h3>{{ $t('modals.cookie18.def.title') }}</h3>
            <p v-html="$t('modals.cookie18.def.content')"></p>

            <div class="form__group-row">
                <button class="btn btn" @click="accept(true)">{{ $t('modals.cookie18.def.accept') }}</button>
            </div>

            <p>
                <a class="link" @click="manageCookies = !manageCookies">{{ $t('modals.cookie18.def.managecookies') }}</a>
                <span class="rowpad">{{ $t('modals.cookie18.def.or') }}</span>
                <a class="link" @click="redirect()">{{ $t('modals.cookie18.def.rejectcookies') }}</a>
            </p>
        </div>
        <div class="cookiee__text-wrapper" v-if="manageCookies">
            <h3>{{ $t('modals.cookie18.def.managecookies') }}</h3>
            <p v-html="$t('modals.cookie18.def.managecookies-desc')"></p>
            <div class="cookiee__toggles">

                <div class="cookiee__toggles-toggle form__group" v-for="(cookie, key) in toggles">
                    <span>
                        <label class="label toggle light" :for="cookie.name" :class="{'disabled': key === 0 }">
                            <input type="checkbox" :id="cookie.name" class="toggle__input" v-model="cookie.value" />
                            <div class="toggle__control"></div>
                        </label>
                    </span>
                    <span>
                        <h2>{{ $t('modals.cookie18.def.'+ cookie.name +'-cookies') }}</h2>
                        <p class="nomar" v-html="$t('modals.cookie18.def.'+ cookie.name + '-cookies-des')"></p>
                    </span>
                </div>
            </div>
            <div class="cookiee__form">
                <a class="link mr" @click="accept(false)">{{ $t('modals.cookie18.def.confirm') }}</a>
                <button class="btn btn ml" @click="accept(true)">{{ $t('modals.cookie18.def.acceptall') }}</button>
            </div>
        </div>
    </div>

    <div class="cookiee__text" v-if="isCC">
        <h4>{{ $t('modals.cookie18.usa.title') }}</h4>
        <div class="cookiee__text-legal">
            <span v-html="$t('modals.cookie18.usa.content')"></span>
            <span v-html="$t('modals.cookie18.usa.terms', {terms: links.terms, policy: links.policy})"></span>
        </div>
        <div class="form__group-row">
            <a class="link mr" @click="redirect">{{ $t('modals.cookie18.usa.exit') }}</a>
            <button class="btn btn ml" @click="accept(true)">{{ $t('modals.cookie18.usa.agree') }}</button>
        </div> 
    </div>

    <div class="cookiee__text-labels">
        <a href="https://www.safelabeling.org/" target="_blank" rel="noopener noreferrer nofollow" class="safe-link">
            <span class="fa-label fa-label-safe" :class="{'fa-label-dark': config.Themename !== 'dusk'}"></span>
        </a>
        <a href="https://www.rtalabel.org/" target="_blank" rel="noopener noreferrer nofollow" class="rta-link">
            <span class="fa-label fa-label-rta"></span>
        </a>
        <a href="https://www.asacp.org/?content=validate&ql=3819e7cd92698397cd85523a18ce88ee" v-if="config.Themename === 'thuis'" target="_blank" rel="noopener noreferrer nofollow" class="asacp-link">
            <span class="fa-label fa-label-asacp"></span>
        </a>
    </div>
</div>
 